import { render, staticRenderFns } from "./SesionesFormativaRegistra.vue?vue&type=template&id=cb4e6676&"
import script from "./SesionesFormativaRegistra.vue?vue&type=script&lang=js&"
export * from "./SesionesFormativaRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports